import { Box, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

const Spinner = ({ text }) => {
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <CircularProgress color="primary" size="1.5em" />{' '}
      <Typography color="primary">{text || 'Chargement...'}</Typography>
    </Box>
  );
};
export default Spinner;
